/**
 * Country Profile translations - Japanese
 */

export const countryProfile = {
  countryProfile: {
    // Page structure
    pageTitle: '国別プロフィール',
    backToRankings: 'ランキングに戻る',
    viewFullProfile: '完全なプロフィールを見る',
    
    // Hero section
    yfiScore: '若者未来指数',
    vsGlobal: 'vs 世界平均',
    classification: '分類',
    region: '地域',
    
    // Quick stats
    youthPopulation: '若者人口',
    jciMembers: 'JCI会員',
    jciSince: 'JCI加盟',
    neetRate: 'NEET率',
    
    // Section titles
    demographics: '人口統計',
    jciPresence: 'JCIプレゼンス',
    dimensionAnalysis: '次元分析',
    mentalHealth: 'メンタルヘルス',
    workforce: '労働力と教育',
    entrepreneurship: '起業家精神',
    keyPrograms: '主要プログラムと組織',
    sdgAlignment: 'SDG整合性',
    recommendations: '戦略的提言',
    communityImpact: 'コミュニティへの影響',
    
    // Demographics labels
    totalPopulation: '総人口',
    medianAge: '中央年齢',
    urbanPopulation: '都市人口',
    genderDistribution: '性別分布',
    racialComposition: '人種構成',
    incomeDistribution: '所得分布',
    
    // Racial composition
    pardo: 'パルド（混血）',
    preto: 'プレト（黒人）',
    branco: 'ブランコ（白人）',
    other: 'その他',
    
    // Income levels
    highIncome: '高所得',
    upperMiddle: '中上位',
    lowerMiddle: '中下位',
    lowIncome: '低所得',
    
    // JCI Presence
    affiliationYear: '加盟年',
    currentMembers: '現在の会員数',
    yearOverYearGrowth: '前年比成長',
    historicalPeak: '過去最高',
    memberProfile: '会員プロフィール',
    ageDistribution: '年齢分布',
    educationLevel: '教育レベル',
    genderBalance: 'ジェンダーバランス',
    motivationLevel: 'モチベーションレベル',
    higherEducation: '高等教育',
    postGraduate: '大学院',
    mastersOrHigher: '修士以上',
    veryMotivated: '非常に意欲的',
    motivated: '意欲的',
    neutral: '中立',
    demotivated: '意欲低下',
    
    // Challenges
    keyChallenges: '主要な課題',
    mentalHealthCrisis: 'メンタルヘルス危機',
    climateAnxiety: '気候不安',
    youthAnxiety: '若者の不安',
    frequentSadness: '頻繁な悲しみ',
    frequentNervousness: '頻繁な緊張感',
    adolescentDisorders: '障害を持つ青少年',
    girlsAffected: '影響を受けた女子',
    boysAffected: '影響を受けた男子',
    highestGlobally: '世界最高',
    neetPopulation: 'NEET若者',
    youth: '若者',
    intersectionalGap: '交差的格差',
    blackBrownWomen: '黒人/混血女性',
    whiteMen: '白人男性',
    
    // Workforce labels
    literacyCrisis: '識字率（小学2年）',
    higherEducationGap: '高等教育格差',
    intersectionalNeet: '交差的ニート',
    
    // Entrepreneurship labels
    blackEntrepreneurs: '黒人起業家',
    informalSector: '非公式セクター',
    microentrepreneurs: '個人事業主（MEI）',
    earlyStageEntrepreneurship: '初期段階の起業活動',
    businessSurvivalRate: '事業生存率（2年）',
    
    // Programs
    programName: 'プログラム',
    programFocus: 'フォーカス',
    programImpact: 'インパクト',
    
    // SDG
    sdgInitiatives: '主要イニシアチブ',
    
    // Recommendations
    urgentPriorities: '緊急優先事項（0-6ヶ月）',
    mediumTermGoals: '中期目標（6-12ヶ月）',
    longTermVision: '長期ビジョン（1-3年）',
    
    // Common
    years: '年',
    million: '百万',
    thousand: '千',
    percent: '%',
    ofPopulation: '人口の',
    source: '出典',
    dataNote: 'JCI影響報告書2025、Atlas das Juventudes、IBGE、WHOのデータ',
    
    // Not found
    notFound: '国別プロフィールが見つかりません',
    notFoundDescription: 'リクエストされた国のプロフィールはまだ利用できません。',
    browseRankings: '国別ランキングを閲覧',
    
    // Research Sources Section
    dataSources: '調査情報源',
    dataSourcesDescription: 'この国プロフィールで使用された主要データソース',
    primarySources: '主要ソース',
    methodology: '方法論',
    sampleSize: 'サンプルサイズ',
    confidenceLevel: '信頼水準',
    organization: '組織',
    researchYear: '年',
    respondents: '回答者',
    
    // Violence & Safety Section
    violenceSafety: '暴力と安全',
    violenceSafetyDescription: 'ブラジルの若者に影響を与える重要な安全指標',
    youthHomicideShare: '若者の殺人被害者割合',
    ofAllHomicides: '全殺人の',
    racialDisparity: '人種格差',
    blackYouthMurderRisk: '黒人若者の殺人リスク',
    timesHigher: '倍高い',
    policeViolence: '警察暴力',
    policeViolenceVictims: '警察暴力被害者の割合は黒人',
    lgbtqiaViolence: 'LGBTQIA+暴力',
    annualIncrease: '報告された暴力の年間増加',
    
    // Organizational Health Section
    organizationalHealth: '組織の健全性',
    organizationalHealthDescription: 'JCIブラジル会員の満足度とエンゲージメント指標',
    netPromoterScore: 'ネットプロモータースコア',
    excellent: '優秀',
    promoters: '推奨者',
    passives: '中立者',
    detractors: '批判者',
    localSatisfaction: '地域満足度',
    nationalSatisfaction: '全国満足度',
    outOfTen: '10点中',
    npsBreakdown: 'NPS内訳',
    satisfactionScores: '満足度スコア',
    
    // SWOT Analysis Section
    swotAnalysis: 'SWOT分析（会員認識）',
    swotAnalysisDescription: 'JCIブラジル会員調査からの戦略的評価',
    strengths: '強み',
    weaknesses: '弱み',
    opportunities: '機会',
    threats: '脅威',
    membersIdentified: '会員が特定した割合',
    companionship: '仲間意識',
    personalDevelopment: '自己成長',
    networking: 'ネットワーキング',
    ego: 'エゴ',
    lackOfCommitment: 'コミットメント不足',
    internalPolitics: '内部政治',
    businessOpportunities: 'ビジネス機会',
    internationalExchange: '国際交流',
    youthInSociety: '社会における若者',
    governmentRelations: '政府との関係',
    externalCompetitors: '外部競合',
    economicCrisis: '経済危機',
    
    // Geographic Distribution Section
    geographicDistribution: '地理的分布',
    geographicGap: '地理的分布',
    geographicGapDescription: 'JCIブラジルの州別会員集中度',
    stateConcentration: '州別集中度',
    southRegionDominance: '南部地域の優位性',
    expansionOpportunity: '拡大機会',
    expansionOpportunityText: '若者開発ニーズが最も高い北部/北東部での存在感が最小限',
    members: '会員',
    ofMembership: '会員の',
    memberConcentration: '会員集中度',
    northNortheast: '北部/北東部',
    limitedPresence: '限定的なプレゼンス',
    
    // Training Insights Section
    trainingInsights: '研修参加',
    trainingInsightsDescription: 'JCIブラジル研修コース修了率',
    noTrainingCompleted: '研修未完了',
    trainingGapAlert: 'JCI研修コースを修了していない会員の割合',
    courseCompletionRates: 'コース修了率',
    completionRate: '修了率',
    trainingParticipation: '研修参加',
    topCourses: 'トップコース',
    
    // SDG Preferences Section  
    sdgPreferences: 'SDG会員優先事項',
    sdgPreferencesDescription: 'JCIブラジル会員の上位関心SDG（今後3年間）',
    memberInterest: '会員関心度',
    topPriority: '最優先',
    alignsWithNationalNeeds: '国の若者課題と整合',
    sdgMemberPriorities: 'SDG会員優先事項',
    
    // Research Sources
    researchSources: '調査情報源',
    primaryDataSources: '主要データソース',
    marginOfError: '誤差範囲',
    
    // Sample label
    sample: 'サンプル',

    // SWOT Items (20 keys)
    swotItems: {
      companionship: '仲間意識',
      committedLeadership: 'コミットしたリーダーシップ',
      continuousTraining: '継続的な研修',
      purposeInDna: 'DNAに刻まれた使命',
      qualityNetworking: '質の高いネットワーキング',
      inflatedEgos: '肥大化したエゴ',
      bureaucracy: '官僚主義',
      inconclusiveProcesses: '結論の出ないプロセス',
      closedOrganization: '閉鎖的な組織',
      lackOfMarketing: 'マーケティング不足',
      grantsAndSponsorships: '助成金とスポンサーシップ',
      personalDevelopmentNecessity: '自己啓発の必要性',
      marketDemandsNewLeaders: '市場が新しいリーダーを求めている',
      digitalPlatforms: 'デジタルプラットフォーム',
      digitalMarketing: 'デジタルマーケティング',
      rapidSocietalChange: '急速な社会行動の変化',
      digitalEntertainment: 'デジタルエンターテインメント',
      growingNgos: '増加する社会系NGO',
      lackOfRecognizedProjects: '認知されたプロジェクトの不足',
      societyWithoutTime: '時間のない社会',
    },

    // SDG Titles (9 keys)
    sdgTitles: {
      qualityEducation: '質の高い教育',
      goodHealth: 'すべての人に健康と福祉を',
      decentWork: '働きがいも経済成長も',
      peaceJustice: '平和と公正をすべての人に',
      reducedInequalities: '人や国の不平等をなくそう',
      genderEquality: 'ジェンダー平等を実現しよう',
      noPoverty: '貧困をなくそう',
      sustainableCities: '住み続けられるまちづくりを',
      climateAction: '気候変動に具体的な対策を',
    },

    // Training Courses (10 keys)
    trainingCourses: {
      jciImpact: 'JCIインパクト',
      jciAchieve: 'JCIアチーブ',
      projectManagement: 'プロジェクト管理',
      jciAdmin: 'JCIアドミン',
      effectiveLeadership: '効果的なリーダーシップ',
      networking: 'ネットワーキング',
      communications: 'コミュニケーション',
      presenter: 'プレゼンター',
      leadershipAcademy: 'リーダーシップアカデミー',
      jciDiscover: 'JCIディスカバー',
    },

    // Brazil-specific Demographics
    brazilDemographics: {
      urbanPopulationBrazil: '主に都市部、ファベーラに約1600万人',
    },

    // Research Methodologies (5 keys)
    methodologies: {
      methodologyAtlas: '3段階調査：定量分析（IBGEデータ）、定性インタビュー、政策提言',
      methodologySuaVoz: 'SurveyMonkey、40.7%回答率、±4%誤差範囲、95%信頼度',
      methodologyConjuve: '若者の態度と課題に関する全国調査',
      methodologyConvid: '青少年のメンタルヘルス行動調査',
      methodologyAtlasViolencia: '殺人と暴力データの分析',
    },

    // Brazil-specific Recommendations (12 keys)
    brazilRecommendations: {
      urgentRec1: '黒人/混血女性のNEET危機に対処（43.3%の割合）',
      urgentRec2: '気候不安に対するメンタルヘルスプログラムを拡大',
      urgentRec3: '北部/北東部に地域支部を立ち上げ',
      urgentRec4: 'ファベーラコミュニティへのアクセスのためCUFAと提携',
      mediumRec1: 'NextGenとJOAJU ITプログラムを全国規模に拡大',
      mediumRec2: 'JCI固有の教育パスウェイを開発',
      mediumRec3: '会員向けメンタルヘルス擁護者研修を作成',
      mediumRec4: '女性起業家ネットワークとの正式なパートナーシップを構築',
      longRec1: 'JCIブラジルをCOP 30若者アジェンダの主要パートナーに位置付け',
      longRec2: '戦略的な若者投資で人口転換に対処',
      longRec3: '人種的公平性に焦点を当てた50-50の男女バランスを達成',
      longRec4: 'ブラジル全27州に拠点を設立',
    },
  },
};
